// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18xPy","importantInfo":"styles_importantInfo__1c3fm"};